import React from "react";

const Loader = () => (
  <div className="min-h-screen bg-ink flex items-center justify-center">
    <div className="flex flex-col items-center gap-6">
      <img src="/horns-logo-dark.webp" alt="Horns Industriservice" className="h-12 w-auto animate-pulse" />
      <div className="h-8 w-8 border-2 border-white/20 border-t-gold rounded-full animate-spin" />
    </div>
  </div>
);

export default Loader;
